import { endpoints } from 'services/endpoints';
import request from 'services/request';
import { paramsToFormData } from 'utils/utils';

export default {
  postBillList: (params: ProjectListReqDto): Promise<CommonSearchListResDto> =>
    request({
      url: endpoints.bill.list,
      method: 'post',
      data: paramsToFormData(params),
    }),   
  postBillPublicInfo: (params: CommonIdReqDto): Promise<BillInfoResDto> =>
    request({
      url: endpoints.bill.info.public,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postBillRequestInfo: (params: CommonIdReqDto): Promise<BillInfoResDto> =>
    request({
      url: endpoints.bill.info.request,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postBillInfoUpdate: (params: BillInfoSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.bill.info.update,
      method: 'post',
      data: paramsToFormData(params),
    }),   
  postBillInfoUpdateStatus: (params: BillInfoSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.bill.info.update_status,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postBillInfoInsertB2B: (params: BillInfoSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.bill.info.insert_b2b,
      method: 'post',
      data: paramsToFormData(params),
    }), 
  postBillPublicB2cInfo: (params: CommonIdReqDto): Promise<BillB2CInfoResDto> =>
    request({
      url: endpoints.bill.b2c.info.public,
      method: 'post',
      data: paramsToFormData(params),
    }),  
  postBillRequestB2cInfo: (params: CommonIdReqDto): Promise<BillB2CInfoResDto> =>
    request({
      url: endpoints.bill.b2c.info.request,
      method: 'post',
      data: paramsToFormData(params),
    }),    
  postBillInfoInsertB2C: (params: BillInfoSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.bill.b2c.info.insert,
      method: 'post',
      data: paramsToFormData(params),
    }), 
};
